export default __webpack_public_path__ + "static/media/18.52fd9b5e.svg";